import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container, Button} from 'react-bootstrap';
import RendConf from './RendConf';
import RegisztracioFejlec from './RegisztracioFejlec';

// A mentett (kifizetett vagy ingyenes) regisztráció áttekintése: felül a szokásos fejléc, alatta a rendezvény
// áttekintő sablonjának (Twig) megjelenítése, majd a törlés és a visszalépés lekerekített gombjai.
export default function Review({betoltottMegrendelesData, felhasznalo, ...props}) {
    const navigate = useNavigate();

    function onClick_torolni(megrendelesID){
        var answer = window.confirm("Valóban törölni szeretné a regisztrációt?");
        if (answer){
            props.callAPI("General.deleteMegrendeles", {megrendelesID: megrendelesID}, function(){
                alert("Regisztrációját töröltük!")
                props.frissitFelhasznalo(function(){
                    navigate('/rendezvenyek', {replace: true});
                });
            });
        }
    }

    return(
        <Container className="reviewOldal">
    <RegisztracioFejlec felhasznalo={felhasznalo} rendezveny={betoltottMegrendelesData.rendezveny} onKilepes={props.onKilepes} />
    <div className="reviewBox">
        <div className="reviewBevezeto">
            <div className="reviewIkon">&#10003;</div>
            <div className="reviewCim">A regisztráció sikeresen megtörtént!</div>
            Az alábbi adatokat e-mailben is elküldtük a megadott címre.<br />
            Az üzenetben egy linket is talál, mellyel később is visszatérhet erre az oldalra.
        </div>

        <div className="megrendelesHTML" dangerouslySetInnerHTML={{__html: betoltottMegrendelesData.html}} />

        <div className="reviewAlja">
        {Number(betoltottMegrendelesData.rendezveny.Megrendelestorolheto) === 1 ?
            <div className="reviewTorles">
                <Button variant="outline-danger" className="reviewGomb" onClick={onClick_torolni.bind(this, betoltottMegrendelesData.Id)}>Regisztráció törlése</Button>
            </div>
            :
            <div className="reviewTorles">Ha kérdése van (regisztráció módosítása, törlése stb.), kérje segítségünket az {RendConf.contact_email} címen!</div>
        }

        <div className="nefeledje">
            <div className="nefeledjeCim">Ne feledje!</div>
            Egyéb rendezvényeinkre is várjuk szeretettel!
            <div><Link to="/rendezvenyek" className="btn reviewGomb reviewGombFo">Vissza a rendezvényekhez</Link></div>
        </div>
        </div>
    </div>
    </Container>
    )
}
